<template>
  <div>
    <!-- DATE TYPE -->
    <span v-if="headerItem.type == Date">{{ rowCell[headerKey] | moment }}</span>

    <!-- DATETIME TYPE -->
    <span v-else-if="headerItem.type == 'datetime'">{{ rowCell[headerKey] | datetime }}</span>

    <!-- PILL TYPE -->
    <span v-else-if="headerItem.type == 'pill'">
      <span
        class="inline-flex px-3 text-sm font-semibold rounded-full"
        :class="
          rowCell[headerKey] == headerItem.firstColorConditional
            ? `bg-${headerItem.colors[0]}-200 text-${headerItem.colors[0]}-900`
            : `bg-${headerItem.colors[1]}-200 text-${headerItem.colors[1]}-900`
        "
      >{{ rowCell[headerKey] }}</span>
    </span>

    <!-- OBJECT TYPE -->
    <span v-else-if="headerItem.type == Object">{{ rowCell[headerKey][headerItem.field] }}</span>

    <!-- BOOLEAN TYPE -->
    <span
      v-else-if="headerItem.type == Boolean"
      :class="{'flex justify-center': !small}"
    >
      <span v-if="rowCell[headerKey] == 1">
        <IconGreenCheck />
      </span>
      <span v-else>
        <IconRedCheck />
      </span>
    </span>

    <!-- CURRENCY AND DEFAULT TYPES -->
    <p v-else>
      <span v-if="headerItem.type == 'currency'">{{ toFixedValue(rowCell[headerKey]) }}</span>
      <span v-else>{{ rowCell[headerKey] }}</span>
      <small
        v-if="headerItem.type == 'currency'"
        class="text-gray-800"
        :class="[small ? 'text-sm' : 'text-base']"
      >&euro;</small>
    </p>
  </div>
</template>

<script>
export default {
  name: "DatatableCell",
  props: {
    headerItem: {
      type: [String, Object],
      default: ""
    },
    headerKey: {
      type: String,
      default: ""
    },
    rowCell: {
      type: Object,
      default: () => {}
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toFixedValue(value) {
      return parseFloat(value).toFixed(2);
    }
  }
};
</script>